import { getScrollContainer } from './utils/scroll-container';

const SCROLL_ANCHOR_SELECTOR = '.js-collections-scroll';

const findInPageTarget = (anchor: HTMLAnchorElement): HTMLElement | null => {
  const url = new URL(anchor.href);

  if (!url.hash || url.origin !== window.location.origin || url.pathname !== window.location.pathname) {
    return null;
  }

  return document.getElementById(url.hash.slice(1));
};

const preventDefaultNavigation = (event: MouseEvent): void => {
  event.preventDefault();
};

const scrollToTarget = (target: Element): void => {
  const container = getScrollContainer();
  
  if (container instanceof HTMLElement) {
    const containerTop = container.getBoundingClientRect().top;
    const targetTop = target.getBoundingClientRect().top;
    const offsetPosition = container.scrollTop + (targetTop - containerTop);
    
    container.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  } else {
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
};

const focusTarget = (target: HTMLElement): void => {
  if (!target.hasAttribute('tabindex')) {
    target.setAttribute('tabindex', '-1');
  }

  target.focus({ preventScroll: true });
};

const handleAnchorClick = (event: MouseEvent): void => {
  const anchor = event.currentTarget as HTMLAnchorElement;
  const target = findInPageTarget(anchor);

  if (target) {
    preventDefaultNavigation(event);
    scrollToTarget(target);
    focusTarget(target);
  }
};

const attachScrollListener = (anchor: HTMLAnchorElement): void => {
  anchor.addEventListener('click', handleAnchorClick);
};

const getScrollAnchors = (): NodeListOf<HTMLAnchorElement> => {
  return document.querySelectorAll<HTMLAnchorElement>(SCROLL_ANCHOR_SELECTOR);
};

const init = (): void => {
  const anchors = getScrollAnchors();
  
  anchors.forEach(attachScrollListener);
};

export { init };
